// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"169865ae","142":"e7c60dcb","396":"68b624a2","618":"ef92d0bc","620":"13a06e7f","691":"e9a37a33"}[chunkId] + ".chunk.js";
};